// extracted by mini-css-extract-plugin
export default {"root":"MultiLineCell_root__cV41L","placeHolderShimmer":"MultiLineCell_placeHolderShimmer__qu2eE"};